import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { compose, branch, renderNothing } from 'recompose';


import withData from './graphql';
import FileViewer from './FileViewer';


const propTypes = exact({
  /* eslint-disable react/no-unused-prop-types */
  documentId: PropTypes.number.isRequired,
  /* eslint-enable react/no-unused-prop-types */

  document: PropTypes.object.isRequired,
  setSelectedIndex: PropTypes.func.isRequired,
});


class DocumentViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: 0,
    };

    this.selectIndex = this.selectIndex.bind(this);
    this.UNSAFE_componentWillReceiveProps = this.UNSAFE_componentWillReceiveProps.bind(this);
  }

  UNSAFE_componentWillReceiveProps(ownProps) {
    const { fileCount } = ownProps.document;
    const { selectedIndex } = this.state;

    if (selectedIndex > fileCount - 1) {
      this.setState({
        selectedIndex: fileCount - 1,
      });
      this.props.setSelectedIndex(fileCount - 1);
    }
  }

  selectIndex(selectedIndex) {
    const { fileCount } = this.props.document;

    if (selectedIndex >= 0 && selectedIndex < fileCount) {
      this.setState({
        selectedIndex,
      });
      this.props.setSelectedIndex(selectedIndex);
    }
  }

  render() {
    const { selectedIndex } = this.state;
    const { fileCount, uploadedFiles, multipage } = this.props.document;

    const file = uploadedFiles.edges[selectedIndex].node;

    return (
      <FileViewer
        selectedIndex={selectedIndex}
        selectIndex={this.selectIndex}
        fileCount={fileCount}
        multipage={multipage}
        file={file}
      />
    );
  }
}


DocumentViewer.propTypes = propTypes;


const withHide = branch(
  (props) => { return props.documentId === null; },
  renderNothing,
);


const enhance = compose(
  withData,
  withHide,
);


export default enhance(DocumentViewer);
